export default function Search() {
    return <h2>AI Search</h2>;
}